import { Typography } from "@mui/material"
import { translate } from "app/language/service"
import { IOperator } from "operator/model"
import { getStringOperatorId } from "operator/tools/common"
import React from "react"

interface ICampaignOperatorsSummaryProps {
  operators: IOperator[]
}

export const CampaignOperatorsSummary = React.memo(({ operators }: ICampaignOperatorsSummaryProps) => {
  if (operators.length === 0) {
    return (
      <Typography id="summary-operator-empty" color="textSecondary" fontSize=".85rem" sx={{ ml: "1rem" }}>
        {translate("operators.empty")}
      </Typography>
    )
  }
  return (
    <>
      {operators.map((operator, index) => (
        <Typography
          id={`summary-operator-${index}`}
          key={getStringOperatorId(operator)}
          fontSize=".8rem"
          color="textPrimary"
          sx={{ border: theme => theme.palette.border, p: ".3rem", pl: ".5rem", pr: ".5rem", borderRadius: ".125rem" }}>
          {operator.publisher_name}
        </Typography>
      ))}
    </>
  )
})
